
import React, { useEffect, useRef, useState } from "react";
import FilterIcon from "../../assets/Icons/FilterIcon";
import ArrowIcon from "../../assets/Icons/ArrowIcon";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { getAllClientsApi, getfilteredClientsApi, getNextClientsApi } from "../../slices/salesSlice";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import useSalesDropdown from "../../utils/dropdown-options/useSalesDropdown";
import ExportExcel from "./ExportExcel";
import useLocations from "../../utils/dropdown-options/useLocations";
import SearchIcon from "../../assets/Icons/SearchIcon";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import FileIcon from "../../assets/Icons/FileIcon";
import Popup from "../../components/popup/Popup";
import PdfView from "./PdfView";
import { baseUrl } from "../../constant";
import DocToImageViewer from "../../components/pdf-viewer/DocToImageViewer";

const sections = [
  {
    name: "Clients Details",
    columns: [
      // { key: "clientID", label: "Client ID / Account Number" },
      // { key: "clientAddress", label: "Client Address" },
      // { key: "leadOwner", label: "Lead Owner" },
      // { key: "clientIndustry", label: "Client Industry" },
      // { key: "onboardingDate", label: "On boarding Date" },
      // { key: "location", label: "Location" },
      { key: "clientName", label: "Client Name" },
      { key: "clientEmail", label: "Client EMail" },
      { key: "domain", label: "Client Domain" },
      {key:"engageWith",label:"Engage With"},
      {key:"engangementType",label:"Engangement Type"},
      {key:"status",label:"Status"},
      {key:"stages",label:"Stages"},
      {key:"subStages",label:"Sub_Stages"},
      {key:"industry",label:"Industry"},
      {key:"location",label:"Location"},
      {key:"remarks",label:"Remarks"}
    ],
  },
  // {
  //   name: "Key Terms",
  //   columns: [
  //     { key: "contractType", label: "Contract Type" },
  //     { key: "paymentTerms", label: "Payment Terms" },
  //   ],
  // },
  {
    name: "Agreements",
    columns: [
            { key: "agreementFile", label: "Agreement File" },
            { key: "agreementStartDate", label: "Agreement Start Date" },
            { key: "agreementEndDate", label: "Agreement End Date" },
            { key: "newOrRenew", label: "Ag. New or Renew" },
            { key: "nonDisclosureAgreement", label: "Ag. Non Disclosure" },
            { key: "agreementStage", label: "Agreement Stage" },
            { key: "agreementType", label: "Agreement Type" },
            { key: "paymentTerms", label: "Ag. Payment Terms" },
            { key: "profileValidity", label: "Profile validity" },
            { key: "paymentSchedule", label: "Ag. payment Schedule" },
            { key: "paymentScheduleAmount", label: "Ag. Payment Schedule Amount" },
            { key: "paymentSchedulePercentage", label: "Ag. payment Schedule %" },
           
    ],
     
  },
  // {
  //   name: "Revenue",
  //   columns: [{ key: "revenue", label: "Revenue" }],
  // },
];


const  columns = [
  { header: 'Client Name', key: 'clientName', width: 30 },
  { header: 'Client Email', key: 'clientEmail', width: 30 },
  { header: 'Domain', key: 'domain', width: 30 },
  { header: 'Enagage With', key: 'engageWith', width: 30 },
  { header: 'Engagement Type', key: 'engagementType', width: 30 },
  { header: 'stages', key: 'stages', width: 30 },
  { header: 'subStages', key: 'subStages', width: 30 },
  { header: 'serviceAgreement', key: 'Service agreement', width: 60 },
  { header: 'status', key: 'status', width: 30 },
  { header: 'Primary Contact', key: 'primaryContact', width: 30 },
  { header: 'remarks', key: 'remarks', width: 30 },
  { header: 'lead Owner', key: `leadOwner`, width: 30 },
];


const ClientManagement = () => {
  const dispatch=useAppDispatch()
  const {clients} = useAppSelector((state)=>state.sales)
  const {session}=useAppSelector((state)=>state.login)
  const [search, setSearch] = useState("");
  const {memberDetails} = useAppSelector((state) => state.member);
  const {companyDetails} = useAppSelector((state) => state.company);
  const [viewAgreementPopup, setViewAgreementPopup] = useState(false);
  const [agreementUrl,setAgreementUrl]=useState("")
  const [selectedColumns, setSelectedColumns] = useState(
    sections.reduce((acc, section) => {
      section.columns.forEach((col) => {
        acc[col.key] = true;
      });
      return acc;
    }, {})
  );

  const [openSection, setOpenSection] = useState(""); // Track only the currently open section
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    defaultRevenue,
    defaultEngageWith,
    defaultSalesIndustry,
    defaultStatus,
    defaultSalesStages,
    defaultSalesSubStages,
    defaultEngagementType,
    defaultAgPaymentTerms,
    defaultAgPaymentSchedule,
    defaultAgProfileValidity
    
  } = useSalesDropdown();

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const {defaultLocation,defaultLocations}=useLocations();
  useEffect(()=>{
    // dispatch(getAllClientsApi())
    // dispatch(getfilteredClientsApi({stages:'3'}));
    dispatch(getfilteredClientsApi({stages:'3',engageWith:`${session?.who=='company'?companyDetails.id:memberDetails.companyId}`}));
  },[])



  const toggleColumn = (key) => {
    setSelectedColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleSection = (name) => {
    setOpenSection((prev) => (prev === name ? null : name)); // If the same section is clicked, close it; else open the clicked section
  };

  const toggleSectionCheckbox = (sectionName) => {
    const section = sections.find((section) => section.name === sectionName);
    const allSelected = section.columns.every(
      (col) => selectedColumns[col.key]
    );

    const newSelectedColumns = { ...selectedColumns };
    section.columns.forEach((col) => {
      newSelectedColumns[col.key] = !allSelected; // If all selected, deselect, else select
    });
    
    newSelectedColumns["clientName"]=true
    setSelectedColumns(newSelectedColumns);
  };

  const toggleSpecificSection = (sectionName) => {
    const section = sections.find((section) => section.name === sectionName);
    setOpenSection(section.name);

    const newSelectedColumns = {};

    // Loop through all sections
  sections.forEach((sec) => {
    
    // If the current section is the one we want to toggle, handle its columns
    if (sec.name === sectionName) {
      sec.columns.forEach((col) => {
        newSelectedColumns[col.key] = true; // Toggle the columns for this section
      });
    } else {
      // If the section is not the one we're toggling, set all columns to false
      sec.columns.forEach((col) => {
        newSelectedColumns[col.key] = false;
      });
    }
  });
    
  newSelectedColumns["clientName"]=true
    setSelectedColumns(newSelectedColumns);
  };

  const resetColumns = () => {
    // Reset selected columns to the initial state (all selected)
    const initialColumns = sections.reduce((acc, section) => {
      section.columns.forEach((col) => {
        acc[col.key] = true; // Set all columns as selected
      });
      return acc;
    }, {});
    setOpenSection("")
    setSelectedColumns(initialColumns);
  };

  const getMoreDataHandler = () => {
    try {
      dispatch(getNextClientsApi());
      // console.log(clients,"CLIENTSHHKDHJKDGH",filteredClients)
    } catch (error) {
      toast.error("Unable to fetch data");
    }
  };

   const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.toLowerCase();
      setSearch(value);
  
      // Clear the previous timeout if it exists
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        dispatch(getfilteredClientsApi({ search: value ,stages:'3',engageWith:`${session?.who=='company'?companyDetails.id:memberDetails.companyId}`}));
      }, 500); 
  
    };

  const toggleAgreementPopupHandler = (url) => {
    setAgreementUrl(url)
    setViewAgreementPopup(!viewAgreementPopup);
  };

  return (
    <div className="flex flex-col relative h-screen">
      <div className="flex items-center gap-4 py-2 ">
        <h1 className="text-xl font-semibold">Client List</h1>
        <div className="relative">
          <input
                type="text"
                placeholder="Search Clients..."
                value={search}
                onChange={handleSearch}
                className="border border-gray-300 rounded-md pl-8 pr-4 py-2 w-72 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <div className="absolute top-2 pl-1">
                <SearchIcon />
              </div>
        </div>
        <div className="flex gap-2 items-center">
          {/* <FilterIcon /> */}
          {/* <button className="bg-primary-600 text-white px-6 py-1 rounded">
            Export
          </button> */}

          
          {/* <ExportExcel columns={columns} array={clients?.clients}/> */}
        </div>
      </div>

      <div className="flex gap-8 py-3 px-4 bg-white">
         <h1 onClick={resetColumns} className={`${openSection?"":"text-primary-600 font-semibold"} text-exgray-300 cursor-pointer`}>All</h1>
        {sections.map((section) => (
          <div key={section.name} className="flex items-center gap-2">
            <h1
              className={`text-exgray-300 cursor-pointer ${
                openSection === section.name
                  ? "text-primary-600 font-semibold"
                  : ""
              }`}
              onClick={() => toggleSpecificSection(section.name)}
            >
              {section.name}
            </h1>
          </div>
        ))}
         
      </div>
     

      {/* Table Section */}
      <div className={`transition-all ${sidebarOpen ? "w-3/4 overflow-y-scroll" : "w-full overflow-y-scroll"}`}>
      
        <InfiniteScroll
                 className=""
                 dataLength={clients?.clients?.length || 0}
                 next={() => getMoreDataHandler()}
                 hasMore={clients?.metadata?.nextResultURL ? true : false}
                 height={"calc(100vh - 155px)"}
                 loader={""}
               >
        <table className="min-w-full bg-white relative ">
          <thead className="sticky top-0">
            <tr className="bg-primary-600">
              <th></th>
              {sections.flatMap((section) =>
                section.columns.map(
                  (col) =>
                    selectedColumns[col.key] && (
                      <th
                        key={col.key}
                        className="border-r font-normal border-white px-4 py-2 text-left text-nowrap text-white"
                      >
                        {col.label}
                      </th>
                    )
                )
              )}
            </tr>
          </thead>
          {/* <tbody>
            {clients?.clients?.map((row, index) => (
              <tr key={index} className="border text-exgray-500">
                <td className="border px-2 py-2 text-center">{index+1}</td>
                {sections.flatMap((section) =>
                  section.columns.map(
                    (col) =>
                      selectedColumns[col.key]  && (
                        selectedColumns[col.key]==="clientName"?
                        <td key={col.key} className="border px-4 py-2">
                          {row[col.key]}
                        </td>
                        :
                       
                        <td key={col.key} className="border px-4 py-2 hover:text-secondary-600">
                          <Link to={`/company-admin/sales/detail/${row.id}`}>
                          {row[col.key]}
                          </Link>
                        </td>
                       

                      )
                  )
                )}
              </tr>
            ))}
          </tbody> */}
          <tbody>
            {clients?.clients?.map((row, index) => (
              <tr key={index} className="border text-exgray-500 ">
                <td className="border px-2 py-2 text-center">{index + 1}</td>
                {sections.flatMap((section) =>
                  section.columns.map((col) => {
                    if (selectedColumns[col.key]) {
                      if (col.key === "clientName") {
                        return (
                          <td key={col.key} className="border px-4 py-2 hover:text-secondary-600">
                             <Link to={`/company-admin/sales/detail/${row.id}`}>
                              {row[col.key]}
                            </Link>
                          </td>
                        );
                      } 
                      if (col.key === "engageWith") {
                        return (
                          <td key={col.key} className="border px-4 py-2 ">
                              {defaultEngageWith(row[col.key])}
                           </td>
                        );
                      } 
                      if (col.key === "status") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultStatus(row[col.key])}
                           </td>
                        );
                      } 
                      if (col.key === "agreementStartDate") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {row?.serviceAgreement?.agreementStartDate 
                                ? new Date(row?.serviceAgreement?.agreementStartDate).toLocaleDateString() 
                                : 'N/A' // or any placeholder text you prefer
                                }
                           </td>
                        );
                      }
                      if (col.key === "agreementEndDate") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                            {row?.serviceAgreement?.agreementEndDate 
                                ? row?.serviceAgreement?.agreementEndDate=="0001-01-01T00:00:00Z"?"Till termination":new Date(row?.serviceAgreement?.agreementEndDate).toLocaleDateString() 
                                : 'N/A' // or any placeholder text you prefer
                            }
                              {/* {new Date(row?.serviceAgreement?.agreementEndDate).toLocaleDateString()} */}
                           </td>
                        );
                      }
                      if (col.key === "agreementFile") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                            <div className="flex items-center justify-center">
                              {row?.serviceAgreement?.agreementFile?<span onClick={()=>toggleAgreementPopupHandler(row?.serviceAgreement?.agreementFile)}><FileIcon/></span>:"Not Available"}
                            </div>
                           </td>
                        );
                      }
                      if (col.key === "agreementStage") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultSalesSubStages(row?.serviceAgreement?.agreementStage)}
                           </td>
                        );
                      }
                      if (col.key === "agreementType") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultEngagementType(row?.serviceAgreement?.agreementType)}
                           </td>
                        );
                      }
                      if (col.key === "newOrRenew") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {row?.serviceAgreement?.newOrRenew}
                           </td>
                        );
                      }
                      if (col.key === "nonDisclosureAgreement") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {row?.serviceAgreement?.nonDisclosureAgreement}
                           </td>
                        );
                      }
                      if (col.key === "paymentTerms") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultAgPaymentTerms(row?.serviceAgreement?.paymentTerms)}
                           </td>
                        );
                      }
                      if (col.key === "paymentSchedule") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultAgPaymentSchedule(row?.serviceAgreement?.paymentSchedule)}
                           </td>
                        );
                      }
                      if (col.key === "paymentScheduleAmount") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {(row?.serviceAgreement?.paymentScheduleAmount)}
                           </td>
                        );
                      }
                      if (col.key === "paymentSchedulePercentage") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {(row?.serviceAgreement?.paymentSchedulePercentage)}
                           </td>
                        );
                      }
                      if (col.key === "agreementFile") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap">
                              {(row?.serviceAgreement?.agreementFile)}
                           </td>
                        );
                      }
                      if (col.key === "profileValidity") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultAgProfileValidity(row?.serviceAgreement?.profileValidity)}
                           </td>
                        );
                      }
                      if (col.key === "subStages") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultSalesSubStages(row[col.key])}
                           </td>
                        );
                      }
                      if (col.key === "stages") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultSalesStages(row[col.key])}
                           </td>
                        );
                      }
                      if (col.key === "industry") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultSalesIndustry(row[col.key])}
                           </td>
                        );
                      }
                      if (col.key === "location") {
                        return (
                          <td key={col.key} className="border px-4 py-2 text-nowrap ">
                              {defaultLocation(row[col.key])?.Name}
                           </td>
                        );
                      }
                      else {
                        return (
                          <td key={col.key} className="border px-4 py-2 ">
                              {row[col.key]}
                          </td>
                        );
                      }
                    }
                    return null; // This ensures that if the condition is not met, nothing is rendered
                  })
                )}
              </tr>
            ))}
          </tbody>
         
        </table>
        {(clients?.clients?.length === 0 || clients?.clients == null ) && (
              <div className="text-center py-4 text-gray-500">
                No Clients found.
              </div>
            )}
        </InfiniteScroll>
      </div>
      
      {/* Column Selector Sidebar */}
      <div
        className={`fixed top-32 right-0 transition-all border-l border-gray-300 bg-white shadow-md ${
          sidebarOpen ? "w-1/4 p-4 overflow-auto " : "w-0 overflow-hidden"
        }`}
        style={{ height: "calc(100vh - 100px)" }}
      >
        {sidebarOpen && (
          <div className="overflow-auto">
            <h3 className="text-lg font-semibold mb-2">Select Columns</h3>
            {sections.map((section) => (
              <div key={section.name} className="">
                <div className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    checked={section.columns.every(
                      (col) => selectedColumns[col.key]
                    )}
                    onChange={() => toggleSectionCheckbox(section.name)}
                    className=""
                  />
                  <button
                    className="w-full flex justify-between items-center font-semibold p-2"
                    onClick={() => toggleSection(section.name)}
                  >
                    {section.name}
                    <span>
                      {openSection === section.name ? (
                        <div className="rotate-180">
                          <ArrowIcon />
                        </div>
                      ) : (
                        <div>
                          <ArrowIcon />
                        </div>
                      )}
                    </span>
                  </button>
                </div>
                {openSection === section.name && (
                  <div className="p-4 ">
                    {section.columns.map(
                      (col) =>
                        col.key !== "clientID" && (
                          <div key={col.key} className="flex items-center ">
                            <input
                              type="checkbox"
                              id={col.key}
                              checked={selectedColumns[col.key]}
                              onChange={() => toggleColumn(col.key)}
                              className="mr-2"
                            />
                            <label htmlFor={col.key}>{col.label}</label>
                          </div>
                        )
                    )}
                  </div>
                )}
              </div>
            ))}

            <div className="flex  justify-end">
              <button
                onClick={resetColumns}
                className="w-fit text-end  text-primary-500  font-semibold px-4 py-2 rounded mt-1 mb-4 hover:scale-90"
              >
                Reset
              </button>
            </div>
          </div>
        )}
      </div>
      
      {/* Sidebar Toggle Button */}
      <button
        className="fixed top-[9.5rem] -translate-y-1/2 right-0 bg-yellow-300 px-3 py-1 rounded-l-full shadow-md "
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        {sidebarOpen ? (
          <div className="-rotate-90">
            <ArrowIcon color="#142243" strokeWidth="3" />
          </div>
        ) : (
          <div className="rotate-90">
            <ArrowIcon color="#142243" strokeWidth="3" />
          </div>
        )}
      </button>
      <Popup
        visible={viewAgreementPopup}
        onClose={()=>setViewAgreementPopup(!viewAgreementPopup)}
        isCloseButton={true}
        // children={<PdfView src={`${baseUrl}/${agreementUrl}?t=${session.token}` }/>}
        children={<DocToImageViewer docUrl={`${baseUrl}/${agreementUrl}?t=${session.token}` }/>}
          />
    </div>
  );
};

export default ClientManagement;
